<template>
    <MenuBase :hidden="props.hidden" 
        :tooltipPosition="props.tooltipPosition" 
        :theme="props.theme" 
        :tooltipText="props.tooltipText"
        @click="toggleMetronome()">
        <MetronomeIcon class="size-6 text-indigo-500 hover:text-indigo-400 transition-colors" />
    </MenuBase>
</template>
<script setup>
import { defineProps, defineEmits } from 'vue'
import MenuBase from '@/components/common/menus/MenuBase.vue';
import MetronomeIcon from '@/components/icons/MetronomeIcon.vue';
import { appEvents } from '@/store/app.events';

const emit = defineEmits(['toggleMetronome']);
const props = defineProps({
    disabled: {
        type: Boolean,
        default: false
    },
    hidden: {
        type: Boolean,
        default: false
    },
    tooltipPosition: {
        type: String,
        default: 'top'
    },
    theme: {
        type: String,
        default: 'light'
    },
    tooltipText: {
        type: String,
        default: 'Metrônomo'
    }
});

const toggleMetronome = () => {
    emit('toggleMetronome');
    appEvents.emit('toggleMetronome');
};
</script>
